var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social",staticStyle:{"font-size":"2em"}},_vm._l((_vm.socials),function(social){return _c('a',{key:social.id,attrs:{"href":social.href,"target":"_blank"}},[_c('i',{class:social.icon,attrs:{"aria-hidden":"true"}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59912423","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/Social.vue
// module id = null
// module chunks = 